import { render, staticRenderFns } from "./LicensesPending.vue?vue&type=template&id=2b5232a0"
import script from "./LicensesPending.vue?vue&type=script&lang=js"
export * from "./LicensesPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports